import { useGlobalStore, useUserStore } from '@shared/store';
import { commonApi } from '../../apis';

// 初始化当前登录用户公共属性
export const initUserPublicProps = async () => {
  try {
    const { firstEntryStaffId } = useGlobalStore();
    const userStore = useUserStore();
    const { userInfo } = userStore;

    const { ret, retdata = {} } = await commonApi.getUserPublicProps<any, any>({
      // 取值优先级：1、初始访问页面 url 参数；2、当前登录用户信息；3、否则置空
      staffId: firstEntryStaffId || userInfo.staffId || '',
    });

    ret === 0 && userStore.setUserProps(retdata);
  } catch (error) {
    console.log('初始化当前登录用户公共属性错误：', error);
  }
};
